/**
 * How hard an exercise felt, as the person says it — and the RPE that answer
 * is recorded as. The ONE mapping: the live workout's chips on an exercise's
 * last set and the finished-workout log both read it from here.
 *
 * ── ONCE PER EXERCISE, NEVER PER SET ───────────────────────────────────────
 * A rating per set is a question nobody answers with a dumbbell in each hand,
 * and an unanswered question is what kept every app-logged set at `rpe: null`
 * — which the engine's double progression reads as "no evidence of comfort",
 * forever. So the question is asked once, on the exercise's last set, and the
 * engine reads an exercise's effort from the sets that carry one
 * (`progression.ts`). Optional: no answer sends no `rpe` at all.
 *
 * ── THREE ANSWERS, IN REPS IN RESERVE ──────────────────────────────────────
 * "Leve" is three or more reps left (RPE 7), "Puxado" one or two (8.5), "No
 * limite" none (10). The numbers are chosen against the two thresholds the
 * engine and `next-suggestion.ts` share: only "Leve" is comfortable enough to
 * earn a load step (`MAX_COMFORT_RPE`), and "No limite" reads as near-failure
 * (`HIGH_RPE_THRESHOLD`). `effort.test.ts` holds them to that.
 */
/** The three answers, lightest first — the order the chips are drawn in. */
export const EFFORTS = ["easy", "hard", "limit"];
/** The RPE each answer is recorded as. */
export const EFFORT_RPE = Object.freeze({
    easy: 7,
    hard: 8.5,
    limit: 10,
});
/** The `rpe` a set is logged with: the answer's, or `null` for none. */
export function rpeOfEffort(effort) {
    return effort === null ? null : EFFORT_RPE[effort];
}
/**
 * Whether the set about to be logged is the exercise's LAST target set — the
 * one the effort question rides on. `done` sets logged of `target`.
 */
export function asksEffort(done, target) {
    return target > 0 && done === target - 1;
}
//# sourceMappingURL=effort.js.map